import { Component, ViewEncapsulation, input } from '@angular/core';
import { LogoBlockComponent, LogoItem } from '../logo-block/logo-block';

@Component({
  selector: 'ds-logo-section',
  templateUrl: './logo-section.html',
  styleUrl: './logo-section.scss',
  encapsulation: ViewEncapsulation.None,
  imports: [LogoBlockComponent],
})
export class LogoSectionComponent {
  readonly sectionId = input<string>('');
  readonly logos = input.required<LogoItem[]>();
  readonly heading = input<string>('');
  readonly background = input<string>('');
  readonly cssClass = input<string>('');
}
